import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

/**
 * Quill/Parchment Blot to allow table placeholders
 * @class TableBlot
 * @extends BlockEmbed
 */
export class TableBlot extends BlockEmbed {

  /** @inheritdoc */
  static blotName: string = 'table';

  /** @inheritdoc */
  static tagName: string = 'TABLE';

  /** @inheritdoc */
  static value(domNode) {
    return domNode;
  }

  /** @inheritdoc */
  static create(value) {
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/table/table.blot.ts